module.exports = __webpack_public_path__ + "img/CM-CA-111722-Ford-Modern.7719aa89.jpg";